import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

export default class c70v extends cView { // 設備予約　管理用用画面

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stgs = { //  子で上書き
};

$cd_stss = { // 親を上書き
  sdld_c70rListsss: {c70r:[]},
  s_c70ri11d: ff.myDT_getDate('today'),
};

static op_loadSlcList = pd => 
  (pd.elm == 'c700') ?
    super.op_loadSlcList({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ?? cf.c('c700', `c700i11d >= "${pd.sttDate}" AND c700i11d <= "${pd.endDate}"`, true, false); // c60v との違い
        //ff.l('c70v 36: {}'.f(_cnd))
        return _cnd;
      }),
    })
  :super.op_loadSlcList(pd);

static op_loadList = pd => 
  (pd.elm == 'c70r') ?
    super.op_loadList({
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        let _cnd = pd.cnd ?? cf.c('c70r', null, true, false); // c60v との違い
        //ff.l('c70v 47: {}'.f(_cnd))
        return _cnd;
      }),
      ld_sortss: [
        { fld: 'c70ri11s', dtn: 'desc', mode: 'nmb' }
      ],
      ...pd,
    })
  :super.op_loadList(pd);

static op_loadDtl = pd => 
  (pd.elm == 'c70r') ?
    super.op_loadDtl({
      o_cnd: pd.o_cnd ?? (_dd_datss => {
        //ff.l('c70v 61: {}'.f(_dd_datss))
        //ff.l('c70v 62: {}'.f())
        let _cnd = pd.cnd ?? cf.c('c70r', `_key = ${global.t?.state.sgc_pageKey}`, true, false); // c60v との違い
        //ff.l('c70v 63: {}'.f(_cnd))
        return _cnd;
      }),
      dd_cldDefss: {
        c700: {
          elm: 'c700',
          o_cnd: _dd_datss => {
            let _cnd = cf.c('c700', `c700br1k = ${_dd_datss.c70r.d_flds._key}`, true, false); // c60v との違い
            return _cnd;
          },
        }
      },
      ...pd,
    })
  :super.op_loadDtl(pd);

$clp_loadLists = () => [ // 親を上書き
  c70v.op_loadList({
    elm: 'c70r',
  }),
];

$clp_loadDtls = () => [
  c70v.op_loadDtl({
    elm: 'c70r',
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_c70rDtlsss',
    b_vsn: false, // c60v との違い
    dd_elmDefss: {
      c70r: {
        b_fnd: true, // c60v との違い
        b_setPageKey: true,
        od_insDats: _dd_datss => {
          let _d = {
            c70ri11s: _dd_datss.c70r.d_flds.c70ri11s ?? '',
          };
          return _d;
        },
        dd_cldDefss: {
          c700: {
            b_fnd: true, // c60v との違い
            b_setPageKey: false,
            od_insDats: _dd_datss => {
              let _d = {
                c700br1k: global.t?.state.sgc_pageKey ?? -1,
                c700i11d: _dd_datss.c700.d_flds.c700i11d ?? '',
              };
              return _d;
            },
          },
        },

      },
    },
  }),
];

render() {
  return (
    ce.c(ce.RootDtl, {
      key: -10,
      d_hdrs: {
        pfx:
          (global.t?.state.sgc_pnlMode == 'list') ?
            '祝日一覧'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            '祝日一覧'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            '祝日変更'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            '新規祝日登録'
          : null,
/*
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
*/
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -10,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_bdys: {
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -10,
                    state: 'sdld_c70rListsss',
                    dd_elmDefss: {
                      c70r: {
                        elm: 'c70r',
                        pfx: '対象年',
                        b_row: true,
                        b_hdr: true,
                        b_ttl: false,
                        d_btns: {
                          d_dlts: {
                            b_vsb: (global.t?.state.sgc_pageMode == 'edit') ? true : false,
                          },
                        },
                        d_insFlds: cf.e('c70r').d_insFlds,
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c70ri11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(5), },
                            d_bdys: { n_w: ic.s(5), },
                          }),
                        ]),
                      },
                    },
                  }),
                ])

              ],
            },
            d_btms: {

              l_clds: [
                ce.c(ce.Box, {
                  key: -10,
                  stlCta: {
                    minHeight: ic.s(2 * 2),
                    width: ic.gn_minBdyW,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginTop: ic.s(0.5), // 20211202
                    marginBottom: ic.s(0.5), // 20211202
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -20,
                    pfx: '前の画面に戻る',
                    stlBtn: {
                      width: ic.s(10),
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                    o_onPrs: () => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.t?.state.sgc_pageRole,
                        sgc_pageName: 'c20v1a',
                        sgc_pageMode: 'show',
                      }; 
                      cf.myRN_move_fwd(_d_pageInfs);
                    },
                  }),
                  ce.c(ce.Btn, {
                    key: -10,
                    pfx: '新規祝日設定',
                    b_rvs: false,
                    stlBtn: {
                      width: ic.s(10),
                    },
                    o_onPrs: () => {
                      cf.myRN_chgPageMode({
                        elm: 'c70r',
                        state: 'sdld_c70rDtlsss',
                        d_insFlds: {
                          ...cf.e('c70r').d_insFlds, 
                          c70ri11i: ff.n(ff.myDT_cnv('year', ff.myDT_add('year', ff.myDT_getDate('today'), 1)))
                        },
                        dld_cldDatsss: {
                          c700: { // 利用室室情報
                            elm: 'c700',
                            d_insFlds: {
                              ...cf.e('c700').d_insFlds, 
                            },
                          },
                        },
                        mode: 'sttNew',
                        b_clr: true, // 現行要素の初期化に必要
                      })
                    },
                  }),
                ])
              ],

            },
          }),

          ce.c(ce.Pnl, {
            key: -20,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
/*
            d_hdrs: {
              d_htys: {
                elm: 'c70r',
                ld_iss: global.t?.state.sdld_c70rVsnListsss?.c70r,
                op_loadDtl: c70v.op_loadDtl,
              },
            },

*/
            d_bdys: {
              d_msgBfrs:
              (global.t?.state.sgc_pnlMode == 'dtl' && ff.i(global.t?.state.sgc_pageMode, ['edit', 'new'])) ?
                {
//                pfx: `・右肩に×のある欄の空白部分を押すとカレンダーが表示されますので、該当される日にちを選んでください。×で取り消します。`, 
                  pfx:
                    (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
                      `■追加で表示される欄の空白部分を押すとカレンダーが表示されますので、該当する日にちを選んでください。\n■右肩の×で取り消します。`
                    : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
                      `■追加で表示される欄の空白部分を押すとカレンダーが表示されますので、該当する日にちを選んでください。\n■右肩の×で取り消します。`
                    : null,
                  n_mgnTop: ic.s(1),
                  d_stlCtas: {
                    minWidth: ic.gn_bdyW,
                  },
                }
              : null,
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [

                  ce.c(cr.InpTree, {
                    key: -10,
                    state: 'sdld_c70rDtlsss',
                    dd_elmDefss: {
                      c70r: {
                        elm: 'c70r',
                        b_row: false,
                        b_hdr: true,
                        b_ttl: true,
                        d_cmns: {
                          n_cnt: 1,
                        },
                        d_insFlds: cf.e('c70r').d_insFlds,
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c70ri11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(5), },
                            d_bdys: { n_w: ic.s(5), },
                          }),
                        ]),
                      },
                    },
                  }),

                ]),

                  ce.c(ce.Box, {
                    key: -20,
                    n_mgnTop: ic.s(1),
                  }, [
                    ce.c(cr.InpTree, {
                      key: -20,
                      state: 'sdld_c70rDtlsss',
                      dd_elmDefss: {
                        c70r: {
                          elm: 'c70r',
                          pfx: '祝日',
                          dd_cldDefss: {

                            c700: {
                              elm: 'c700',
                              b_row: false,
                              b_subHdr: false,
                              b_ttl: false,
                              d_btns: {
                                d_btrs: {
                                  pfx: '祝日を追加',
                                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                },
                                d_dlts: {
                                  b_vsb: bf.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? true : false,
                                },
                              },
                              d_insFlds: cf.e('c70r').d_insFlds,
                              d_stlSubBdyCtas: {
                                borderWidth: 0,
                                borderTopWidth: ic.gn_bdrWNrw,
                                borderBottomWidth: ic.gn_bdrWNrw,
                                borderColor: ic.o_getCcd('d'),
                              },
                              dd_fldDefss: cf.myRN_getFldDefs([
                                cf.f('c700i11d', {
                                  d_mdls: 
                                    (global.t?.state.sdld_c70rDtlsss?.c70r && ff.f(global.t?.state.sdld_c70rDtlsss?.c70r[0].d_flds.c70ri11s)) ?
                                      {
                                        iniDate: `${global.t?.state.sdld_c70rDtlsss?.c70r[0].d_flds.c70ri11s}-01-01`,
                                        sttDate: `${global.t?.state.sdld_c70rDtlsss?.c70r[0].d_flds.c70ri11s}-01-01`,
                                        endDate: `${global.t?.state.sdld_c70rDtlsss?.c70r[0].d_flds.c70ri11s}-12-31`,
                                      }
                                    : null,
                                  d_hdrs: { n_w: ic.s(8), },
                                  d_bdys: { n_w: ic.s(8), },
                                }),
                              ]),
                            },
                          },

                        },
                      },
                      d_stlCtas: {
                        marginTop: ic.s(1.5),
                      },
                    }),
                  ])
//                : null,

              ],
            },
            d_btms: {
              d_btns: {
//                name: 'この祝日',
                name: 'この年の祝日',
                d_stlBtns: {
                  width: ic.s(14),
                },
              },
            },

          }),
        ],
      }
    })
  );
}

}

/*
*/
